import ModuleFactory from "./utilities/module-factory";
import Header from "./header";
import Footer from "./footer";
import Carousel from "./elements/carousel";
import LargeCard from "./elements/large-card";
import AlternatingRow from "./elements/alternating-row";
import RoomNavBar from "./elements/room-nav-bar";
import RoomFeatures from "./elements/room-features";
import Map from "./elements/map";
import Gallery from "./elements/gallery";
import Rooms from "./elements/rooms";
import Room from "./elements/room";

const modules = [
	Header,
	Footer,
	Carousel,
	LargeCard,
	AlternatingRow,
	RoomNavBar,
	RoomFeatures,
	Map,
	Gallery,
	Rooms,
	Room,
];

new ModuleFactory(modules);
